// Common constants for job-related data
export const contractTypes = [
  { value: 'Full-time', label: 'Full Time' },
  { value: 'Part-time', label: 'Part Time' },
  { value: 'Contract', label: 'Contract' },
  { value: 'Permanent', label: 'Permanent' },
  { value: 'Internship', label: 'Internship' },
  { value: 'Freelance', label: 'Freelance' }
];

export const workModes = [
  { value: 'On-site', label: 'On Site' },
  { value: 'Remote', label: 'Remote' },
  { value: 'Hybrid', label: 'Hybrid' }
];

export const jobStatuses = [
  { value: 'active', label: 'Active' },
  { value: 'inactive', label: 'Inactive' },
  { value: 'closed', label: 'Closed' }
];

// Helper function to get contract type label
export const getContractTypeLabel = (value) => {
  const type = contractTypes.find(t => t.value === value);
  return type ? type.label : value;
};

// Helper function to get work mode label
export const getWorkModeLabel = (value) => {
  const mode = workModes.find(m => m.value === value);
  return mode ? mode.label : value;
};

// Helper function to get status label
export const getStatusLabel = (value) => {
  const status = jobStatuses.find(s => s.value === value);
  return status ? status.label : value;
};